export const validateWorkflowRequirements = (need) => {
  const missingFields = [];
  const requiredForWorkflows = [];

  // Check for opportunity workflow requirements
  if (!need.orderClients || need.orderClients.length === 0) {
    missingFields.push({
      field: 'orderClients',
      label: 'Order Client Contacts',
      required: true,
      workflow: 'Opportunity'
    });
  }

  // Check for product workflow requirements  
  if (!need.tjm || need.tjm <= 0) {
    missingFields.push({
      field: 'tjm',
      label: 'TJM (Daily Rate)',
      required: true,
      workflow: 'Product'
    });
  }

  // Check for priority sales assignment
  if (!need.consultants || need.consultants.length === 0) {
    missingFields.push({
      field: 'consultants',
      label: 'Priority Sales Consultant',
      required: true,
      workflow: 'All'
    });
  }

  return { missingFields, requiredForWorkflows };
};
